
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"14","height":"8","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M12.895 0a1.11 1.11 0 00-.782.32L7 5.366 1.887.319a1.117 1.117 0 00-1.564 0 1.083 1.083 0 000 1.544L6.218 7.68a1.117 1.117 0 001.564 0l5.895-5.818a1.082 1.082 0 000-1.544A1.11 1.11 0 0012.895 0z","fill":"#585858"}})])
          )
        }
      }
    